import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { appConstants } from "../appConstants.ts";
import { selectIsAuth } from "../store/selectors";

window.juicyLabConfig = {
  apiKey: appConstants.juicyApiKey,
};

const inculdeJuicy = () => {
  const juicyScript = document.createElement("script");
  juicyScript.type = "text/javascript";
  juicyScript.async = true;
  juicyScript.src = appConstants.juicyRegion;
  const head = document.getElementsByTagName("head")[0];
  head.appendChild(juicyScript);

  return juicyScript;
};

export const useJuicyScript = () => {
  const isAuth = useSelector(selectIsAuth);

  const juicyRef = useRef();

  useEffect(() => {
    // инклудим juicy когда авторизованы
    if (isAuth && !juicyRef.current) {
      juicyRef.current = inculdeJuicy();
    }

    // удаляем juicy если разлогинились или оператор
    if (!isAuth && juicyRef.current) {
      juicyRef.current.remove();
      juicyRef.current = null;
    }

    // чистим за собой
    return () => juicyRef.current?.remove();
  }, [isAuth]);
};
